import { getSequentialColorSceme } from "../../../Colors/ColorControlPanel";
function getLuminance(r, g, b) {
  const a = [r, g, b].map((v) => {
    v /= 255;
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
  });
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722;
}

function hexToRgb(hex) {
  const bigint = parseInt(hex.slice(1), 16);
  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255,
  };
}

function getContrastingFontColor(bgColor = "#FFFFFF") {
  // Ensure bgColor has a value, default to white if undefined
  if (!bgColor) {
    bgColor = "#FFFFFF"; // Default to white background color
  }

  let r, g, b;

  if (bgColor.startsWith("#")) {
    // If it's a hex color, convert to RGB
    ({ r, g, b } = hexToRgb(bgColor));
  } else if (bgColor.startsWith("rgb")) {
    // If it's already in RGB format, extract the values
    const rgbValues = bgColor.match(/\d+/g);
    if (rgbValues) {
      [r, g, b] = rgbValues.map(Number);
    } else {
      // If no valid RGB found, fallback to white
      [r, g, b] = [255, 255, 255];
    }
  } else {
    // If bgColor is not valid, fallback to white
    [r, g, b] = [255, 255, 255];
  }

  const luminance = getLuminance(r, g, b);

  // If luminance is lower than 0.5, use white font, otherwise black
  return luminance < 0.5 ? "White" : "Black";
}

function assignDivergentColor(value, min, max, colorArray) {
  // To avoid log of negative numbers, add a small constant if min is 0 or negative
  const logMin = Math.log(min > 0 ? min : 0.01);
  const logMax = Math.log(max > 0 ? max : 0.01);
  const logValue = Math.log(value > 0 ? value : 0.01);

  const normalized = (logValue - logMin) / (logMax - logMin);
  const clampedValue = Math.max(0, Math.min(normalized, 1)); // Clamp between 0 and 1
  const colorIndex = Math.floor(clampedValue * (colorArray.length - 1));

  return colorArray[colorIndex];
}
export default function CellFormatter(
  measureKey,
  displayValue,
  conditionalFormatting,
  maxMinData,
  isCustomAlign,
  rowAlign,
  valueAlign,
  quickTable,
  grandTotalAccordingToKey,
  columnTotal
) {
  console.log(measureKey);
  console.log(maxMinData);

  // Object to hold the formatted result
  let formattedObject = {
    formattedValue: displayValue,
    fontColor: "#4a5568", // Default font color
    bgColor: "White",
    rowAlignment: isCustomAlign && rowAlign !== undefined ? rowAlign : "left",
    valueAlignment:
      isCustomAlign && valueAlign !== undefined ? valueAlign : "center",
  };
  console.log(conditionalFormatting);
  // Step 1: Find the formatting rule for the measureKey
  const formattingRule = conditionalFormatting.find((format) => {
    console.log(`${format.measure.value}_${format.rename}`);

    return `${format.measure.value}_${format.rename}` === measureKey;
  });
  console.log(formattingRule);

  // Case 1: Apply manual rules if found
  if (formattingRule !== undefined && !formattingRule.isColorScaleAuto) {
    const { rulesArray } = formattingRule;
    console.log(rulesArray);

    rulesArray.forEach((rule) => {
      const { value1, value2, conditions, style } = rule;

      const numericValue = parseFloat(displayValue);
      const parsedValue1 = parseFloat(value1);
      const parsedValue2 = value2 ? parseFloat(value2) : null;

      switch (conditions) {
        case "LessThan":
          if (numericValue < parsedValue1) {
            formattedObject.fontColor =
              style.color || formattedObject.fontColor;
            formattedObject.bgColor =
              style.backgroundColor || formattedObject.bgColor;
          }
          break;
        case "LessThanOrEqualTo":
          if (numericValue <= parsedValue1) {
            formattedObject.fontColor =
              style.color || formattedObject.fontColor;
            formattedObject.bgColor =
              style.backgroundColor || formattedObject.bgColor;
          }
          break;
        case "GreaterThan":
          if (numericValue > parsedValue1) {
            formattedObject.fontColor =
              style.color || formattedObject.fontColor;
            formattedObject.bgColor =
              style.backgroundColor || formattedObject.bgColor;
          }
          break;
        case "GreaterThanOrEqualTo":
          if (numericValue >= parsedValue1) {
            formattedObject.fontColor =
              style.color || formattedObject.fontColor;
            formattedObject.bgColor =
              style.backgroundColor || formattedObject.bgColor;
          }
          break;
        case "EqualTo":
          if (numericValue === parsedValue1) {
            formattedObject.fontColor =
              style.color || formattedObject.fontColor;
            formattedObject.bgColor =
              style.backgroundColor || formattedObject.bgColor;
          }
          break;
        case "DoesNotEqual":
          if (numericValue !== parsedValue1) {
            formattedObject.fontColor =
              style.color || formattedObject.fontColor;
            formattedObject.bgColor =
              style.backgroundColor || formattedObject.bgColor;
          }
          break;
        case "Between":
          if (
            numericValue >= parsedValue1 &&
            parsedValue2 !== null &&
            numericValue <= parsedValue2
          ) {
            formattedObject.fontColor =
              style.color || formattedObject.fontColor;
            formattedObject.bgColor =
              style.backgroundColor || formattedObject.bgColor;
          }
          break;
        case "NotBetween":
          if (
            (numericValue < parsedValue1 || numericValue > parsedValue2) &&
            parsedValue2 !== null
          ) {
            formattedObject.fontColor =
              style.color || formattedObject.fontColor;
            formattedObject.bgColor =
              style.backgroundColor || formattedObject.bgColor;
          }
          break;
        default:
          console.log("Unknown condition type: ", conditions);
          break;
      }
    });
  }

  // Case 2: Apply auto color scaling if enabled
  else if (formattingRule && formattingRule.isColorScaleAuto) {
    const numericValue = parseFloat(displayValue);
    const key = `${formattingRule.measure.value}_${formattingRule.rename}`;
    console.log(key);
    const totalkey = `Total ${formattingRule.measure.value}_${formattingRule.rename}`;
    console.log(totalkey);

    // Ensure quickTable is an array before calling .find on it
    const quickObject = Array.isArray(quickTable)
      ? quickTable.find((quick) => quick.quickTableKey === key)
      : undefined;

    console.log(quickObject !== undefined && quickObject.quickOption);
    console.log(maxMinData);
    console.log(maxMinData[key]);

    const { min: minValue, max: maxValue } = maxMinData[key];
    // console.log(minValue);
    // console.log(maxValue);

    let minPercentage, maxPercentage;

    if (
      quickObject &&
      [
        "percentageOfColumnTotal",
        "percentageOfRowTotal",
        "percentageOfGrandTotal",
        "tableDifferenceDownPercentage",
        "tableDifferenceAcrossPercentage",
      ].includes(quickObject.quickOption)
    ) {
      const grandTotal =
        formattingRule.measure.value === "AVG"
          ? parseFloat(
              grandTotalAccordingToKey && grandTotalAccordingToKey[0][key]
            )
          : columnTotal[totalkey];
      console.log(grandTotal);

      if (grandTotal) {
        minPercentage = (minValue / grandTotal) * 100;
        maxPercentage = (maxValue / grandTotal) * 100;
      }
    } else {
      minPercentage = minValue;
      maxPercentage = maxValue;
    }
    console.log(minPercentage !== undefined && minPercentage);
    console.log(maxPercentage !== undefined && maxPercentage);

    const colorWillApplyOn = formattingRule.colorWillApplyOn;
    const isColorInverted = formattingRule.isColorInverted;
    const colorArray = getSequentialColorSceme(
      formattingRule.colorScale
    ).colors;
    const reversedColorArray = isColorInverted
      ? [...colorArray].reverse()
      : colorArray;

    const color = assignDivergentColor(
      numericValue,
      minPercentage,
      maxPercentage,
      reversedColorArray
    );
    console.log(color);
    console.log(colorWillApplyOn);
    console.log(["toCell", "toArea"].includes(colorWillApplyOn));

    formattedObject.bgColor = ["toCell", "toArea"].includes(colorWillApplyOn)
      ? color
      : "White";
    formattedObject.fontColor =
      colorWillApplyOn === "toCell"
        ? getContrastingFontColor(formattedObject.bgColor)
        : color;

    console.log("Auto color scale applied", formattedObject);
  }

  // Case 3: No matching rule
  else {
    console.log("No matching formatting rule found for the given measureKey.");
  }
  // Step 3: Return the formatted object
  return formattedObject;
}
